export enum VehicleStatusEnum {
  "active" = 1,
  "inactive" = 2,
  "standBy" = 3,
  "maintenance" = 4
}